import { ClearwaterTransactionsPanelState } from '../models/clearwater-transactions-panel-state.model'
import { CwTxSummary } from '../models/cw-tx-summary.model'

export const initialPanelState: ClearwaterTransactionsPanelState = {
  filters: {
    clearedTimestampToggle: false,
    unclearedTimestampToggle: false,
  },
  isSelectAllRowsEnabled: false,
  selectedRowsSummaryData: {} as CwTxSummary,
}
